
import * as _ from 'underscore'

import { TypeHelper, LogHelper, ConvertHelper } from '../../../helpers'


// Public Types

export interface IIMRIFrameWrapper<TMessageData> {
    sendMessage(message: TMessageData): void
}

export type IMRIFrameWrapperOptions<TMessageData> = {
    url: string,

    origin?: string
    headers?: { [index: string]: string }

    onError?(): void
    onInitialized?(iframeWrapper: IIMRIFrameWrapper<TMessageData>): void
    onMessage?(message: IMRIFrameWrapperMessage<TMessageData>): void
}

export class IMRIFrameWrapperMessage<TMessageData> {

    // Properties

    public get data(): TMessageData {
        if (this.event.data != null) {
            return this.event.data.message;
        }

        return null
    }

    public get headers(): { [index: string]: any } {
        if (this.event.data != null) {
            return this.event.data.headers
        }

        return null
    }

    // Properties End


    // Ctor

    public constructor(private event: MessageEvent, private iframe: HTMLIFrameElement, private onError: (e: any) => void) { }

    // Ctor End


    // Respond

    public respond<TRespondData>(data: TRespondData): void {
        try {
            this.iframe.contentWindow.postMessage(data, this.event.origin);
        } catch (e) {
            this.onError(e)
        }
    }

    // Respond End
}

// Public Types End


export class IMRIFrameWrapperController<TMessageData> implements ng.IComponentController, IIMRIFrameWrapper<TMessageData> {

    // Consts

    private static get IFRAME_CONTAINER_SELECTOR(): string { return '.iframe-wrapper__container' }
    private static get LOG_PREFIX(): string { return '[SIMAX.Common.IFrameWrapper]' }

    // Consts End


    // Members

    private options: IMRIFrameWrapperOptions<TMessageData>

    private iframe: HTMLIFrameElement
    private iframeOrigin: string

    // Members End


    // Ctor

    constructor(private $element: JQuery, private $sceService: ng.ISCEService) { }

    // Ctor End


    // IIMRIFrameWrapper Implementation

    public sendMessage(message: any): void {
        const preparedMessage: any = this.prepareMessage(message)

        this.iframe.contentWindow.postMessage(preparedMessage, this.iframeOrigin)
    }

    // IIMRIFrameWrapper Implementation End


    // IComponentController Implementation 

    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize();
        }
    }

    public $onDestroy(): void {
        this.unregisterMessageHandler()
    }

    // IComponentController Implementation End


    // Component

    private initialize(): void {
        const $iframe: JQuery = this.prepareIFrame()

        this.iframeOrigin = this.getIFrameOrigin()
        this.iframe = $iframe.get(0) as HTMLIFrameElement

        this.insertIFrame($iframe)
        this.registerMessageHandler()
    }

    // Component End


    // Events

    private onInitialized(): void {
        if (_.isFunction(this.options.onInitialized)) {
            this.options.onInitialized(this)
        }
    }

    private onError(error: any): void {
        LogHelper.warn(IMRIFrameWrapperController.LOG_PREFIX, "An iframe error occured.", error)

        if (_.isFunction(this.options.onError)) {
            this.options.onError()
        }
    }

    private onMessage(message: IMRIFrameWrapperMessage<any>): void {
        if (_.isFunction(this.options.onMessage)) {
            this.options.onMessage(message)
        }
    }

    // Events End


    // IFrame 

    private prepareIFrame(): JQuery {
        const iframeSrc: string = this.$sceService.trustAsResourceUrl(this.options.url)
        const $iframe: JQuery = $('<iframe/>', { style: "width:100%; height: 100%;", src: iframeSrc, frameborder: '0', scrolling: 'no' });

        $iframe.on('load', () => {
            this.onInitialized()
        })

        $iframe.on('error', (error: any) => {
            this.onError(error)
        })

        return $iframe
    }

    private insertIFrame($iframe: JQuery): void {
        this.$element
            .find(IMRIFrameWrapperController.IFRAME_CONTAINER_SELECTOR)
            .append($iframe)
    }


    private getIFrameOrigin(): string {
        if (this.options.origin != null) {
            return this.options.origin
        }

        return ConvertHelper.getOriginFromUrl(this.options.url)
    }

    // IFrame End


    // Message Handler

    private onWindowMessage = (event: MessageEvent) => {
        if (event.source === this.iframe.contentWindow) {
            const message: IMRIFrameWrapperMessage<any> = new IMRIFrameWrapperMessage<any>(
                event,
                this.iframe,
                (error: any) => this.onError(error)
            );

            this.onMessage(message);
        }
    }

    private registerMessageHandler(): void {
        window.addEventListener('message', this.onWindowMessage, false)
    }


    private unregisterMessageHandler(): void {
        window.removeEventListener('message', this.onWindowMessage, false)
    }

    // Message Handler End


    // Messages 

    private prepareMessage(message: any): any {
        return {
            message,
            headers: this.options ? this.options.headers : {}
        }
    }

    // Messages End
}
